import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { ProductPage } from '../product/product.page';

@Component({
  selector: 'app-products',
  templateUrl: './products.page.html',
  styleUrls: ['./products.page.scss'],
})
export class ProductsPage implements OnInit {

  id = '';
  token = '';
  category_name = '';
  products = [];
  loaded: boolean;



  constructor(public activedRoute:ActivatedRoute, public http:HttpClient, public alertCtrl:AlertController, public navCtrl:NavController, public modalController:ModalController) {
    this.id = this.activedRoute.snapshot.paramMap.get('id');
    this.token = localStorage.getItem('token');
    this.getCategory();
    this.getProducts();
  }

  back(){
    this.navCtrl.pop();
  }

  getProducts(){
    this.http.post<any>('https://api.blowjob.cherish.com.ua/api/get_products', {
      id:this.id,
      token: this.token
    }).subscribe(async res => {
      if (res.error_code == 0) {
        this.products = this.formatArray(res.data.products);
        this.loaded = true;
      } else {
        await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Возникла ошибка', buttons: ["OK"] }))).present();
      }
    }, async err => {
      await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Проверьте интернет-соединение', buttons: ["OK"] }))).present();
    })
  }

  getCategory(){
    this.http.post<any>('https://api.blowjob.cherish.com.ua/api/get_category', {
      id:this.id
    }).subscribe(async res => {
      if (res.error_code == 0) {
        this.category_name = res.data.category.name;
      } else {
        await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Возникла ошибка', buttons: ["OK"] }))).present();
      }
    }, async err => {
      await (await (this.alertCtrl.create({ header: 'Ошибка', message: 'Проверьте интернет-соединение', buttons: ["OK"] }))).present();
    })
  }

  ngOnInit() {
  }  
  
  async openProduct(product) {
    const modal = await this.modalController.create({
      component: ProductPage,
      componentProps:{
        id: String(product.id)
      },
      cssClass: 'my-custom-class'
    });
    return await modal.present();
  }

  formatArray(array){
    let result = [];

    let counter = -1;
    for(let i = 0; i < array.length; i++){
      if(i%4 == 0){ counter++; result[counter] = []; }
      result[counter][i%4] = array[i];
    }

    console.log(result);

    return result;
  }

}
